import { render } from "./EditPatient.vue?vue&type=template&id=0ffd892a"
import script from "./EditPatient.vue?vue&type=script&lang=js"
export * from "./EditPatient.vue?vue&type=script&lang=js"

import "./EditPatient.vue?vue&type=style&index=0&id=0ffd892a&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__